import React, { useState, useEffect } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem";

import APSRouting from 'views/aps/tables/APSRouting';
import BOM from 'views/aps/tables/BOM';
import Operation from 'views/aps/tables/Operation';
import styles from 'views/component/Styles.js';
import ToggleInput from 'views/component/ToggleInput';
import WorkingHourPop from "./tables/WorkingHourPop";

const useStyles = makeStyles(styles);

export default function ConditionList(props) {
    const classes = useStyles();
    const { factory, onSave } = props;
    const [operationSelect, setOperationSelect] = useState({});
    const [operationData, setOperationData] = useState([]);
    const [workingHour, setWorkingHour] = useState({});
    const [editPop, openEditPop] = useState(false);

    useEffect(() => {
        if (factory.factory_id){
            axios.get('aps/list/operation', { params: factory }).then(response => {
                onOperationChange(response.data.data);
            });
            getWorkingHour();
        }
    }, []);
    const onOperationChange = function (operationData) {
        setOperationData(operationData);
        const productSelect = [...new Set(operationData.map(item => item.product_id))].map(item => ({ label: item, value: item }));
        const operSelect = [...new Set(operationData.map(item => item.oper_id))].map(item => ({ label: item, value: item }));
        setOperationSelect({ 'product_id': productSelect, 'oper_id': operSelect });
    }
    const taskFilter = function (row, itemList) {
        const taskList = operationData.filter(item => item.product_id === row.product_id).map(item => item.oper_id);
        const filteredList = itemList.filter(item => taskList.includes(item.value));
        return filteredList.length === 0 ? [{ label: '제품 선택되지 않음', value: '' }] : filteredList;
    }
    const handleSave = function () {
        if (onSave) {
            onSave();
        }
    }
    const getWorkingHour = function(){
        axios.get('aps/list/workingHour', { params: factory }).then(response => {
            setWorkingHour(response.data.data?.[0]);
        });
    }
    const handleWorkingHourSave = function(){
        getWorkingHour();
    }
    return (
        <GridContainer>
            <GridContainer style={{ margin: '20px' }}>
                <GridItem md={4} className={classes.center}>
                    <h4><b>{factory.factory_name}</b></h4>
                </GridItem>
                <GridItem md={2} className={classes.center}>
                    <ToggleInput label='일과 시작 기준 시간' value={workingHour.daily_start_time ?? '미입력'} />
                </GridItem>
                <GridItem md={2} className={classes.center}>
                    <ToggleInput label='일과 종료 기준 시간' value={workingHour.daily_end_time ?? '미입력'} />
                </GridItem>
                <GridItem md={4} className={classes.center}>
                    <Button color="infoOutline" className={classes.right} onClick={() => openEditPop(true)}>일과시간 등록</Button>
                </GridItem>
            </GridContainer>
            <Operation factory={factory} onDataChange={onOperationChange} onSave={handleSave} />
            <APSRouting factory={factory} operationSelect={operationSelect} taskFilter={taskFilter} onSave={handleSave} />
            <BOM factory={factory} operationSelect={operationSelect} taskFilter={taskFilter} onSave={handleSave} />
            <WorkingHourPop modal={editPop} factory={factory} onSave={handleWorkingHourSave} onClose={() => openEditPop(false)}/>
        </GridContainer>
    );
}
